<template>
  <div id="app"
    :class="{'settings--inactive': !settingsActive}">
    <router-view @playBeep="playBeep" @makeAnnouncement="makeAnnouncement" />
    <audio id="audio" src="/static/sounds/beep.mp3" preload="auto"></audio>
    <div class="version">0.021</div>
  </div>
</template>

<script>
// import NoSleep from '@hacksawstudios/nosleep.js';

import { mapGetters } from 'vuex';


export default {
  name: 'home',
  components: {},
  data: () => ({
    beep: null,
    beepFile: null,
    beepInitialized: false,
    anouncement: null,
    anouncementVoice: {},
    announcementInitialized: false,
    // noSleep: new NoSleep(),
  }),
  computed: {
    ...mapGetters([
      'settingsActive',
    ]),
  },
  mounted() {
    this.beepFile = document.getElementById('audio');
  },
  methods: {
    setSettingsActive(payload) {
      this.$store.commit('SETSETTINGSACTIVE', payload);
    },
    playBeep() {
      console.log('play beep');
      if (!this.beepInitialized) {
        // this.beep = new Audio('/static/sounds/beep.mp3');
        console.log('play beep init');
        // this.beepFile.play();
        this.beepInitialized = true;
      } else {
        // this.beepFile.src = '/static/sounds/beep.mp3';
        // this.beepFile.play();
      }
      // this.noSleep.enable();
    },
    makeAnnouncement(announcement) {
      console.log('announcement', announcement);
      if (!this.announcementInitialized) {
        console.log('announcement init');
        this.announcement = window.speechSynthesis;
        this.announcementInitialized = true;
        const tospeak = 'Lets go!';
        const utterance = new SpeechSynthesisUtterance(tospeak);
        utterance.addEventListener('error', error => console.error(error));
        utterance.voice = this.announcementVoice;
        utterance.lang = 'en-US';
        speechSynthesis.speak(utterance);
      } else {
        let prefix = '';
        if (announcement.prefix !== '') prefix = `${announcement.prefix}: `;
        const tospeak = `${prefix} ${announcement.title}`;
        const utterance = new SpeechSynthesisUtterance(tospeak);
        utterance.addEventListener('error', error => console.error(error));
        utterance.voice = this.announcementVoice;
        utterance.lang = 'en-US';
        speechSynthesis.speak(utterance);
      }
    },
  },
  created() {
    const getVoices = () => new Promise((resolve) => {
      let voices = speechSynthesis.getVoices();
      console.log('voices', voices);
      if (voices.length) {
        resolve(voices);
        return;
      }
      speechSynthesis.onvoiceschanged = () => {
        voices = speechSynthesis.getVoices();
        resolve(voices);
      };
    });

    const printVoicesList = async () => {
      (await getVoices()).forEach((voice, i) => {
        console.log(i, voice.name, voice.lang);
        if (voice.name === 'Samantha') {
          console.log('got her! guck kkkoool hier no:', voice.name, voice.lang);
          this.announcementVoice = voice;
        }
      });
    };
    printVoicesList();
  },
  watch: {},
};
</script>

<style lang="stylus">
@import '~styles/variables.styl'
@import '~styles/general.styl'
html
  height 100%
  box-sizing border-box
html *
  box-sizing border-box
body
  // padding env(safe-area-inset-top)
  background #2B3F4A url(/static/studioback.jpg) center center no-repeat
  background-size cover
  background-attachment fixed
  height 100%
  overflow hidden
  font-family 'Fira Sans', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color weiss
  @media ls
    background-image url(/static/studioback_quer.jpg)
#app
  height 100vh
#app
  padding-top env(safe-area-inset-top);
.view
  height 100%
  display flex
  flex-direction column
.logo
  display block
  position absolute
  width 100px
  height auto
  left 50%
  margin-left -50px
  transition all .5s ease-in-out
  transform translate3d(0, -60px, 0) scale(.25)
  .settings--inactive &
    transform translate3d(0, 7vh, 0) scale(1)
</style>
